import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IAIS } from '../contracts/ais.contract';
import { AisService } from '../services';

interface IInitialState {
    List: {
        [key: string]:
            | {
                  IMONumber: string;
                  AIS: IAIS | undefined;
                  IsLoading: boolean;
                  ErrorMessage: string | undefined;
              }
            | undefined;
    };
}

const initialState: IInitialState = {
    List: {}
};

const Fetch = {
    GetByImoNumber: createAsyncThunk('ais/GetByImoNumber', async (imoNumber: string, { rejectWithValue }) => {
        try {
            const res = await AisService.getByImoNumber(imoNumber);
            return { IMONumber: imoNumber, res };
        } catch (err) {
            return rejectWithValue(err);
        }
    })
};

const AisSlice = createSlice({
    name: 'ais',
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        // GetByImoNumber
        builder.addCase(Fetch.GetByImoNumber.pending, (state, action: any) => {
            state.List[action.meta.arg] = { IMONumber: action.meta.arg, AIS: undefined, IsLoading: true, ErrorMessage: undefined };
        });
        builder.addCase(Fetch.GetByImoNumber.fulfilled, (state, action: PayloadAction<{ IMONumber: string; res: IAIS }>) => {
            const { IMONumber, res } = action.payload;
            state.List[IMONumber] = { IMONumber: IMONumber, AIS: res, IsLoading: false, ErrorMessage: undefined };
        });
        builder.addCase(Fetch.GetByImoNumber.rejected, (state, action: PayloadAction<any>) => {
            const { IMONumber, res } = action.payload;
            state.List[IMONumber] = { IMONumber: IMONumber, AIS: undefined, IsLoading: false, ErrorMessage: res };
        });
    }
});

export const AisFetch = Fetch;
export const AisAction = AisSlice.actions;
export const AisReducer = AisSlice.reducer;
